import React, { memo } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Notification } from 'rsuite';
import { RootState } from '../../../../../@types/RootState';
import { queryClient } from '../../../../../App';
import { AlertWithTimestamp } from '../../../../../components/AlertWithTimestamp';
import { RESET_DATAPOINTS_CACHE } from '../../../../../reducers/gerenciadorPrecos/datapointsCache';
import { RESET_SELECTED_DATAPOINTS, selectorSelectedDatapoints } from '../../../../../reducers/gerenciadorPrecos/selectedDatapoints';
import { selectorChangePricesModal, SET_IS_OPEN } from '../../../../../reducers/ipa/priceManager/modals/changePrices';
import { useBigNumbersRefresh } from '../../hooks/useBigNumbersRefresh';
import { usePriceManagerDatapointsModel } from '../../hooks/usePriceManagerDatapointsModel';
import { ChangeMassicePrice, changeMassivePrice } from '../../services_ts';
import { AlterarPrecosSchema, ModalAlterarPrecos } from '../ModalAlterarPrecos';

type ChangePricesModalWrapperProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const ChangePricesModalWrapper = ({
  changePrices: { isOpen },
  selectedDatapoints: { selectedIds, excludedIds, selectedAll },
  closeModal,
  resetSelectedDatapoints,
}: ChangePricesModalWrapperProps) => {
  const filters = usePriceManagerDatapointsModel();
  const { refreshBigNumbers } = useBigNumbersRefresh();

  const handleChangeMassivePrices = async (formData: AlterarPrecosSchema) => {
    const model: ChangeMassicePrice = { ...formData, filters, products: { selectedIds, excludedIds }, selectedAll };

    try {
      const data = await changeMassivePrice(model);
      if (!data) return;

      closeModal();
      resetSelectedDatapoints();
      // Antes de checar productsFailed: com falha parcial os demais preços já foram gravados
      await Promise.all([queryClient.invalidateQueries(['ipa.gerenciador.datapoints']), refreshBigNumbers()]);

      if (data.productsFailed) {
        const message = `Houve uma falha na aplicação de preços de ${data.productsFailed} produtos. Os demais foram aplicados normalmente.`;
        AlertWithTimestamp({ message });
        return;
      }

      Notification.success({ description: 'Preços alterados!' });
    } catch {
      AlertWithTimestamp({ message: 'Erro durante a alteração de preços' });
    }
  };

  return <ModalAlterarPrecos show={isOpen} onHide={closeModal} onSubmit={handleChangeMassivePrices} />;
};

const mapStateToProps = (state: RootState) => ({
  changePrices: selectorChangePricesModal(state),
  selectedDatapoints: selectorSelectedDatapoints(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeModal: () => dispatch(SET_IS_OPEN(false)),
  resetSelectedDatapoints: () => {
    dispatch(RESET_SELECTED_DATAPOINTS());
    dispatch(RESET_DATAPOINTS_CACHE());
  },
});

export default memo(connect(mapStateToProps, mapDispatchToProps)(ChangePricesModalWrapper));
